import dayjs from 'dayjs';

export const formatToLongDate = (isoDate) =>
  new Date(isoDate).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

export const formatToShortDate = (date) =>
  new Date(date).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

export const generateYearsFromCurrentYear = (yearCount) => {
  const years = [];
  for (let i = 0; i < yearCount; i++) {
    const year = dayjs().subtract(i, 'year').format('YYYY');
    years.push({ key: year, value: year });
  }
  return years;
};

export const getButtonIconNameColor = (type, selectedType) => {
  let iconName = '';
  let colorVariant = '';
  switch (type) {
    case 'correct':
      iconName = 'Check-mark';
      colorVariant =
        selectedType === type ? 'var(--White)' : 'var(--Green-100)';
      break;
    case 'correct-2':
      iconName = 'Check-mark';
      colorVariant =
        selectedType === type ? 'var(--White)' : 'var(--Green-100)';
      break;
    case 'correct-3':
      iconName = 'Check-mark';
      colorVariant =
        selectedType === type ? 'var(--White)' : 'var(--Green-100)';
      break;
    case 'soundedOut':
      iconName = 'Check-mark';
      colorVariant =
        selectedType === type ? 'var(--White)' : 'var(--Yellow-100)';
      break;
    case 'fluentlyRead':
    case 'correctAlt':
      iconName = 'Check-mark';
      colorVariant =
        selectedType === type
          ? 'var(--Approved-Green-100)'
          : 'var(--Green-100)';
      break;
    case 'correctAlt-2':
      iconName = 'Check-mark';
      colorVariant =
        selectedType === type
          ? 'var(--Approved-Green-100)'
          : 'var(--Green-100)';
      break;
    case 'correctAlt-3':
      iconName = 'Check-mark';
      colorVariant =
        selectedType === type
          ? 'var(--Approved-Green-100)'
          : 'var(--Green-100)';
      break;
    case 'selfCorrect':
      iconName = 'Self-correct-right-mark';
      colorVariant =
        selectedType === type
          ? 'var(--Approved-Green-100)'
          : 'var(--Green-100)';
      break;
    case 'incorrect':
      iconName = 'Incorrect-cross-mark';
      colorVariant = selectedType === type ? 'var(--White)' : 'var(--Red-100)';
      break;
    case 'incorrect-2':
      iconName = 'Incorrect-cross-mark';
      colorVariant = selectedType === type ? 'var(--White)' : 'var(--Red-100)';
      break;
    case 'incorrect-3':
      iconName = 'Incorrect-cross-mark';
      colorVariant = selectedType === type ? 'var(--White)' : 'var(--Red-100)';
      break;
    case 'reversal':
      iconName = 'Self-correct-right-mark';
      colorVariant =
        selectedType === type ? 'var(--Green-50)' : 'var(--Green-100)';
      break;
    case 'incorrectlyFormed':
    case 'incorrectAlt':
      iconName = 'Incorrect-cross-mark';
      colorVariant = selectedType === type ? 'var(--White)' : 'var(--Red-100)';
      break;
    case 'incorrectAlt-2':
      iconName = 'Incorrect-cross-mark';
      colorVariant = selectedType === type ? 'var(--White)' : 'var(--Red-100)';
      break;
    case 'incorrectAlt-3':
      iconName = 'Incorrect-cross-mark';
      colorVariant = selectedType === type ? 'var(--White)' : 'var(--Red-100)';
      break;
    default:
      break;
  }
  return { iconName, colorVariant };
};

//Generate dropdown options for programs
export const generateProgramOptions = (programsData) => {
  let options = [];
  programsData.map((prog) => {
    options.push({ key: prog.program_id, value: prog.program_name });
  });
  return options;
};

//Generate dropdown options for assessment groups
export const generateAsmtGroupOptions = (groupData) => {
  let options = [];
  [...groupData]
    .sort((a, b) => a.group_seq_no - b.group_seq_no)
    .map((grp) => {
      options.push({ key: grp.asmt_group_id, value: grp.group_short_name });
    });
  return options;
};

//Generate dropdown options for parts
export const generateAsmtPartOptions = (partData) => {
  let options = [];
  [...partData]
    .sort((a, b) => a.seq_no - b.seq_no)
    .map((part) => {
      options.push({ key: part.asmt_id, value: part.part_name });
    });
  return options;
};

//Replace key params and create route
export const buildRoutePath = (template, params) =>
  template.replace(/:(\w+)/g, (_, key) => params[key]);

//Generate dropdown options for schools
export const generateSchoolOptions = (schoolData) => {
  const options = (() => {
    const seen = new Set();
    return [...schoolData]
      .sort((a, b) => a.school_id - b.school_id)
      .reduce((acc, school) => {
        if (!seen.has(school.school_id)) {
          acc.push({ key: school.school_id, value: school.school_name });
          seen.add(school.school_id);
        }
        return acc;
      }, []);
  })();
  return options;
};

//get benchmark colors
export const getBenchmark = (score) => {
  let benchmark;
  if (score < 60) {
    benchmark = 'low';
  } else if (score >= 60 && score < 80) {
    benchmark = 'mid';
  } else if (score >= 80) {
    benchmark = 'high';
  }
  return benchmark;
};

//svg to png converter for pdf
export const svgToPngDataUrl = (svgString, width, height) => {
  return new Promise((resolve) => {
    const svgBlob = new Blob([svgString], {
      type: 'image/svg+xml;charset=utf-8',
    });
    const url = URL.createObjectURL(svgBlob);

    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL('image/png'));
    };
    img.src = url;
  });
};
